<template>
  <body>
  </body>
</template>

<script>
  export default {
    name: 'index',
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {
      let accountCode = this.$route.query.accountCode
      let langType = this.$route.query.langType

      console.log('accountCode === ' + accountCode)
      console.log('langType === ' + langType)

      this.superLogin(accountCode,langType)
    },
    methods: {
      superLogin(accountCode,langType){
        this.$axios.get('/api/clienth5/login', {
          params: {
            "accountCode": accountCode,
            "langType": langType
          }
        })
        .then(response => {
          console.log('超级登录接口数据返回')
          console.log(response)
          let code = response.code
          let data = response.data
          let message = response.msg
          if(code == '0'){
            if(langType == 'CN'){
              localStorage.setItem('locale', 'zh')
            }else{
              localStorage.setItem('locale', 'en')
            }
            this.$router.push({
              name: "personaloverview"
            })
          }else if(code == '-1'){
            this.$message.error(message)
          }
        })
        .catch(error => {
          console.log(error);
          this.abnormalSituation()
        });
      }

    },
    components: {

    }
  }
</script>

<style>
</style>
